module.exports = __webpack_public_path__ + "media/images/basic_logos/loader-4a12d087da12c7b7fbd7b0e804a992e5.gif";